import { render, staticRenderFns } from "./Carousell.vue?vue&type=template&id=84ee606c&"
import script from "./Carousell.vue?vue&type=script&lang=js&"
export * from "./Carousell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports